import { SUMMARY_PRODUCT_TYPE } from '../consts/product-capture-field-selectors.consts';

import { FCForm } from '../../model/form-config.interface';
import { AUTOCALL_GROWTH_AT_MATURITY_SETTINGS } from '../../model/product-settings/autocall-growth.settings';
import { AUTOCALL_SETTINGS } from '../../model/product-settings/autocall.settings';
import { BONUS_CERTIFICATE_SETTINGS } from '../../model/product-settings/bonus-certificate.settings';
import { CAPPED_FLOOR_DELTA_N_PRODUCT_SETTINGS } from '../../model/product-settings/capped-floor-delta-n.settings';
import { CHOOSER_SETTINGS } from '../../model/product-settings/chooser.settings';
import { DISCOUNT_CERTIFICATE_SETTINGS } from '../../model/product-settings/discount-certificate.settings';
import { DROPBACK_CERTIFICATE_SETTINGS } from '../../model/product-settings/drop-back-certificate.settings';
import { DUAL_CURRENCY_NOTE_SETTINGS } from '../../model/product-settings/dual-currency-note.settings';
import { EMPTY_PRODUCT_SETTINGS } from '../../model/product-settings/empty-product.settings';
import { FIXED_RATE_NOTE_SETTINGS } from '../../model/product-settings/fixed-rate-note.settings';
import { FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE_SETTINGS } from '../../model/product-settings/fixed-to-floating.settings';
import { FLOATING_RATE_NOTE_SETTINGS } from '../../model/product-settings/floating-rate-note.settings';
import { FX_DIGITAL_COUPON_NOTE_SETTINGS } from '../../model/product-settings/fx-digital-coupon-note.settings';
import { EQ_ISSUER_CALLABLE_SETTINGS } from '../../model/product-settings/issuer-callable.settings';
import { PARTICIPATION_NOTE_SETTINGS } from '../../model/product-settings/participation-note.settings';
import { PERFORMANCE_LINKED_COUPON_SETTINGS } from '../../model/product-settings/performance-linked-coupon.settings';
import { PRDC_SETTINGS } from '../../model/product-settings/prdc.settings';
import { RANGE_ACCRUAL_SETTINGS } from '../../model/product-settings/range_accrual.settings';
import { REVERSE_CONVERTIBLE_BOND_SETTINGS } from '../../model/product-settings/reverse-convertible-bond.settings';
import { REVERSE_CONVERTIBLE_SETTINGS } from '../../model/product-settings/reverse-convertible.settings';
import { SUPERTRACKER_SETTINGS } from '../../model/product-settings/supertracker.settings';
import { WARRANT_SETTINGS } from '../../model/product-settings/warrant.settings';
import { CALL_EVENT_AMOUNT_TYPE } from '../consts/call-event-amount-type.const';
import { CALL_EVENT_BARRIER_TYPE } from '../consts/call-event-barrier-type.const';
import { CALL_EVENT_TYPE } from '../consts/call-event-type.const';
import { COUPON_BARRIER_TYPE } from '../consts/coupon-barrier-type.const';
import { COUPON_TYPE } from '../consts/coupon-type.const';
import { ADDITIONAL_CREDIT_BUSINESS_CENTRE } from '../consts/credit-provision-additional-credit-business-centre.const';
import { EXCLUDED_OBLIGATIONS } from '../consts/credit-provision-excluded-obligations.const';
import { PASS_THROUGH_SECURITIES } from '../consts/credit-provision-pass-through-securities.const';
import { DOWN_SIDE_TYPE } from '../consts/down-side-type.const';
import { LEGAL_SUBSCRIPTION_TYPE } from '../consts/legal-subscription-type.const';
import { CAPITAL_BASE_TYPE } from '../consts/payoff-capital-base-type.const';
import { CAPPED_RULE } from '../consts/payoff-participation-base-capped.const';
import { BASE_TYPE } from '../consts/payoff-participation-base-type.const';
import { REBATE_DATE } from '../consts/payoff-participation-upside-early-termination.const';
import { UPSIDE_TYPE } from '../consts/payoff-participation-upside-type.const';
import { PHYSICAL_SETTLEMENT_MATRIX } from '../consts/physical-settlement-matrix.const';
import { RATE_RESET_SELECTOR } from '../consts/rate-reset.const';
import { REFERENCE_ENTITIES } from '../consts/reference-entities.const';
import { STRIKE_ADJUSTMENT_RATE_BASIS } from '../consts/strike-adjustment-rate-basis.const';
import { UNDERLYING_ASSETS } from '../consts/underlying-assets.const';
import { DB_LEGAL_FORM_TYPE } from './db-legal-form.const';
import { COUPON_FIXED_RATE_TYPE } from '../consts/fixed-coupon-type.const';

export function getDBForm(clnSettings: any): FCForm {
  return {
    name: 'productCapture',
    fields: [
      { ...CAPPED_RULE },
      {
        formControlNames: [SUMMARY_PRODUCT_TYPE],
        options: [
          EMPTY_PRODUCT_SETTINGS,
          AUTOCALL_SETTINGS,
          AUTOCALL_GROWTH_AT_MATURITY_SETTINGS,
          BONUS_CERTIFICATE_SETTINGS,
          CAPPED_FLOOR_DELTA_N_PRODUCT_SETTINGS,
          CHOOSER_SETTINGS,
          clnSettings,
          DISCOUNT_CERTIFICATE_SETTINGS,
          DROPBACK_CERTIFICATE_SETTINGS,
          DUAL_CURRENCY_NOTE_SETTINGS,
          FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE_SETTINGS,
          FIXED_RATE_NOTE_SETTINGS,
          FLOATING_RATE_NOTE_SETTINGS,
          FX_DIGITAL_COUPON_NOTE_SETTINGS,
          EQ_ISSUER_CALLABLE_SETTINGS,
          PARTICIPATION_NOTE_SETTINGS,
          PERFORMANCE_LINKED_COUPON_SETTINGS,
          PRDC_SETTINGS,
          RANGE_ACCRUAL_SETTINGS,
          // TODO: Waiting for more details from Stuart/James/Ben
          // RANGE_ACCRUAL_EQ_SETTINGS, - This product needs the Range Accrual Coupon Type -- which isn't implemented yet.
          // RANGE_ACCRUAL_RATES_SETTINGS, - This product needs the Range Accrual Coupon Type -- which isn't implemented yet.
          // TARGET_REDEMPTION_EQ_SETTINGS, -This product needs the Target Redemption Callability type -- which isn't implemented yet.
          REVERSE_CONVERTIBLE_SETTINGS,
          REVERSE_CONVERTIBLE_BOND_SETTINGS,
          SUPERTRACKER_SETTINGS,
          WARRANT_SETTINGS,
        ],
      },
      { ...COUPON_TYPE },
      { ...COUPON_BARRIER_TYPE },
      { ...CALL_EVENT_BARRIER_TYPE },
      { ...CALL_EVENT_AMOUNT_TYPE },
      { ...DB_LEGAL_FORM_TYPE },
      { ...UNDERLYING_ASSETS },
      { ...REFERENCE_ENTITIES },
      { ...UPSIDE_TYPE },
      { ...STRIKE_ADJUSTMENT_RATE_BASIS },
      { ...REBATE_DATE },
      { ...DOWN_SIDE_TYPE },
      { ...BASE_TYPE },
      { ...CAPITAL_BASE_TYPE },
      { ...CALL_EVENT_TYPE },
      { ...LEGAL_SUBSCRIPTION_TYPE },
      { ...EXCLUDED_OBLIGATIONS },
      { ...PHYSICAL_SETTLEMENT_MATRIX },
      { ...PASS_THROUGH_SECURITIES },
      { ...ADDITIONAL_CREDIT_BUSINESS_CENTRE },
      { ...RATE_RESET_SELECTOR },
      { ...COUPON_FIXED_RATE_TYPE }
    ],
  }
};